import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { IntegrationInterfaceResponse } from '@/main/models/response';

// Redux
import {
  saveDomain,
  saveService,
  GetService,
  GetDomainIntegrationIntegrationInterfaces,
  saveDomainIntegrationIntegrationInterfaces,
  GetIntegrationIntegrationInterface,
  saveIntegrationIntegrationInterface,
  saveIntegrationInterface,
  GetIntegrationInterface
} from './index';

// Api's
import { integrationApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getDomainSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationApi.getDomain
    );

    if (response.data.result) {
      yield put(saveDomain(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveDomain(null, true, resultError.messagesDataError));
    }
  }
}

export function* getServiceSaga(action: GetService) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationApi.getDomainService,
      action.payload
    );

    if (response.data.result) {
      yield put(saveService(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveService(null, true, resultError.messagesDataError));
    }
  }
}

export function* getDomainIntegrationIntegrationInterfacesSaga(
  action: GetDomainIntegrationIntegrationInterfaces
) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationApi.getIntegrIntegrationInterfacesByGuidIntegration,
      action.payload
    );

    if (response.data.result) {
      yield put(
        saveDomainIntegrationIntegrationInterfaces(
          response.data.result,
          false,
          null
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveDomainIntegrationIntegrationInterfaces(
          null,
          true,
          resultError.messagesDataError
        )
      );
    }
  }
}

export function* getIntegrationIntegrationInterfaceSaga(
  action: GetIntegrationIntegrationInterface
) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationApi.getIntegrationIntegrationInterfaces,
      action.payload.guidIntegrationInterface
    );
    if (response.data.result) {
      yield put(
        saveIntegrationIntegrationInterface(response.data.result, false, null)
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      yield put(
        saveIntegrationIntegrationInterface(
          null,
          true,
          resultError.messagesDataError
        )
      );
    }
  }
}

export function* getIntegrationInterfaceSaga(action: GetIntegrationInterface) {
  try {
    const response: AxiosResponse<Result<
      IntegrationInterfaceResponse[]
    >> = yield call(
      integrationApi.getIntegrationInterface,
      String(action.payload.integrationInterfaceFilter.guidIntegration),
      action.payload.integrationInterfaceFilter.idIntegrationType
    );
    if (response.data.result) {
      yield put(saveIntegrationInterface(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      yield put(
        saveIntegrationInterface(null, true, resultError.messagesDataError)
      );
    }
  }
}
